import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "./config";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Detect language from localStorage or default to English
  const [language, setLanguage] = useState(localStorage.getItem("language") || "en");

  // Language Translations
  const text = {
    en: {
      title: "Forgot Password",
      subtitle: "Insert your email address to reset your password.",
      placeholderEmail: "Enter your email",
      button: "Send Reset Link",
      successMessage: "Your password reset link has been sent to your email.",
      errorMessage: "Failed to send reset link. Try again.",
      invalidEmail: "Please enter a valid email address.",
      sending: "Sending...",
    },
    sw: {
      title: "Nimesahau Nenosiri",
      subtitle: "Ingiza barua pepe yako ili kubadilisha nenosiri lako.",
      placeholderEmail: "Ingiza barua pepe yako",
      button: "Tuma Kiungo cha Kubadilisha",
      successMessage: "Kiungo cha kubadilisha nenosiri kimepelekwa kwa barua pepe yako.",
      errorMessage: "Imeshindikana kutuma kiungo cha kubadilisha nenosiri. Jaribu tena.",
      invalidEmail: "Tafadhali ingiza barua pepe sahihi.",
      sending: "Inatuma...",
    },
  };

  // // Automatically redirect to login after success message
  // useEffect(() => {
  //   if (successMessage) {
  //     setTimeout(() => {
  //       navigate("/login"); // Redirect after 3 seconds
  //     }, 3000);
  //   }
  // }, [successMessage, navigate]);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
  
    if (!email.trim()) {
      setError(text[language].invalidEmail);
      return;
    }
  
    setLoading(true);
  
    try {
      console.log("Forgot password clicked");
      console.log("API_BASE_URL:", API_BASE_URL);
      console.log("FULL URL:", "http://127.0.0.1:8080/auth/forgot-password");
      console.log("Payload:", { email, language });
  
      const response = await fetch("http://127.0.0.1:8080/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, language }),
      });
  
      const data = await response.json();
      console.log("Forgot password response status:", response.status);
      console.log("Forgot password response data:", data);
  
      if (response.ok) {
        setSuccessMessage(text[language].successMessage);
      } else {
        setError(data.error || text[language].errorMessage);
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setError(text[language].errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div
          className="container d-flex flex-column align-items-center justify-content-center vh-100"
          style={{marginTop: "-150px"}} // Move container up for both mobile and web
      >
        {/* Logo & Umojai Name on Top Left */}
        <div className="position-absolute top-0 start-0 m-3 d-flex align-items-center">
          <img
              src="/umojai-logo.png"
              alt="Umojai Logo"
              className="logo-img"
              style={{width: "40px", height: "auto", maxHeight: "40px"}}
          />
          <h4 className="fw-bold text-primary ms-2">Umojai</h4>
        </div>

        <h1 className="display-5 fw-bold">{text[language].title}</h1>
        <p className="text-muted">{text[language].subtitle}</p>

        {successMessage && <p className="text-success">{successMessage}</p>}
        {error && <p className="text-danger">{error}</p>}

        <form onSubmit={handleForgotPassword} className="w-50">
          <input
              type="email"
              className="form-control mb-2"
              placeholder={text[language].placeholderEmail}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
          />
          <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
              style={{
                marginLeft: window.innerWidth <= 768 ? "0px" : "auto", // Move the button to the left on mobile
                marginRight: window.innerWidth <= 768 ? "0px" : "auto", // Keep it aligned for web
              }}
          >
            {loading ? text[language].sending : text[language].button}
          </button>
        </form>
      </div>
  );
}
